/**
 * region for libraries*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Chip, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete/Autocomplete';

/**
 * region for hepers*/
import ajax from '../../helpers/ajax';
import Constants from '../../constants/Constants';

/**
 * region for styles*/
import { listChipStyle } from './style/listChipStyle';

class ListChip extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categories: [],
            categoriesFound: []
        }
    }

    componentDidMount() {
        let self = this;
        this.handleSugestCategory(self, '');
    }

    componentWillReceiveProps(nextProps) {
        let categories= [];
        nextProps.items.forEach(function (item) {
            categories.push({ IDCATEGORY: item.IDCATEGORY, DESCRIPTION: item.DESCRIPTION, DEFAULT:1 });
        })
        this.setState({
            categories: categories
        });
    }

    handleDeleteCategory(deletedCategory, event) {
        let self = this;
        let requestData = {
            idkeyword: self.props.keyword.IDKEYWORD,
            keyword: self.props.keyword.KEYWORD,
            idcategory: deletedCategory.IDCATEGORY
        };
        ajax.get(Constants.ROUTE_API_CATEGORIES_DELETE_KEYWORD_CATEGORY,
            {
                requestData: requestData,
                success: function (response) {
                    const listCategories = self.state.categories.filter(k => k.IDCATEGORY !== deletedCategory.IDCATEGORY).map(x =>
                        {
                            return {
                                IDCATEGORY: x.IDCATEGORY,
                                DESCRIPTION: x.DESCRIPTION,
                                DEFAULT: x.DEFAULT
                            }
                        })                      
                    self.setState({
                        categories: listCategories
                    })
                }
            });  
    }

    handleAddCategory(event, values) {
        let self = this;
        values.forEach(function (item) {
            if (item.DEFAULT !== 1) {
                let requestData = {
                    idkeyword: self.props.keyword.IDKEYWORD,
                    keyword: self.props.keyword.KEYWORD,
                    idcategory: item.IDCATEGORY
                };

                let category = { IDCATEGORY: item.IDCATEGORY, DESCRIPTION: item.DESCRIPTION, DEFAULT:1};
                ajax.get(Constants.ROUTE_API_CATEGORIES_INSERT_KEYWORD_CATEGORY,
                    {
                        requestData: requestData,
                        success: function (response) {
                            self.setState({
                                categories: self.state.categories.concat(category)
                            })
                        }
                    });
            }
        })
    }
 
    handleSugestCategory(event, values) {
        let self = this;
        let text = values;
        let requestdata = {
            term: text
        };
        ajax.get(Constants.ROUTE_API_CATEGORIES_AUTOCOMPLETE,
            {
                requestData: requestdata,
                success: function (response) {
                    let sugestCategories=[];
                    response.data.forEach(function (item) {
                        let defaultExist=(self.state.categories.filter(x => x.IDCATEGORY===item.IDCATEGORY).length>0)?1:0;
                        sugestCategories.push({ IDCATEGORY: item.IDCATEGORY, DESCRIPTION: item.DESCRIPTION, DEFAULT:defaultExist });
                    })
                    self.setState({ categoriesFound: sugestCategories })
                }
            });
    }

    render() {
        let self = this;
        const { classes } = this.props;
        return (
            <div className={classes.paddingDetails}>
                <Typography className={classes.subtitle2}
                    variant="body2"
                    display="block">
                    <strong>{this.props.title}</strong>
                </Typography>
                <Autocomplete
                    multiple
                    id="tags-outlined"
                    options={self.state.categoriesFound}
                    getOptionLabel={option => option.DESCRIPTION}
                    value={self.state.categories}
                    filterSelectedOptions
                    renderInput={params => (
                        <TextField
                            {...params}
                            variant="outlined"
                            margin="normal"
                            fullWidth
                        />
                    )}
                    renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                            <Chip
                                key={option.IDCATEGORY}
                                label={option.DESCRIPTION}
                                onDelete={this.handleDeleteCategory.bind(this, option)} />
                        ))
                    }
                    onChange={this.handleAddCategory.bind(this)}
                    onInputChange={this.handleSugestCategory.bind(this)}
                />
            </div>
        );
    }
}
ListChip.propTypes = {
    classes: PropTypes.object.isRequired,
    items: PropTypes.array.isRequired
};
export default withStyles(listChipStyle)(ListChip);





